/* eslint-disable no-underscore-dangle */
import axios from "axios";
import { bankReviewSignInPath } from "../app/routes/bankaccounts/reviewAccess";
import {
  getAccessToken,
  getRefreshToken,
  setTokens,
  clearTokens,
  getUserServer,
} from "./localStorageService";
import { USER_SERVER, FLIP_SERVER_LIST, PRICE_SERVER_LIST } from "./Utility";
import { USER_DATA } from "../constants/ActionTypes";

const normalizeBaseUrlOverride = (value) => {
  const normalized = `${value || ""}`.trim();

  return normalized.replace(/\/+$/, "");
};

const getBaseUrlOverride = (envVar) => {
  return normalizeBaseUrlOverride(process.env[envVar]);
};

const isTokenRequest = (requestUrl = "") => {
  return /\/connect\/token\/?$/i.test(`${requestUrl}`.split("?")[0]);
};

const redirectToSignIn = () => {
  window.location.replace(bankReviewSignInPath(window.location));
};

const getServerKey = (server = getUserServer()) => {
  return (
    Object.keys(USER_SERVER).find((key) => USER_SERVER[key] === server) || "PROD"
  );
};

export const getBaseURL = (server = getUserServer()) => {
  const configuredBaseUrl = getBaseUrlOverride("REACT_APP_FLIP_API_BASE_URL");

  return (
    configuredBaseUrl ||
    FLIP_SERVER_LIST[getServerKey(server)] ||
    FLIP_SERVER_LIST.PROD
  );
};

export const getBasePriceURL = (server = getUserServer()) => {
  const configuredBaseUrl = getBaseUrlOverride("REACT_APP_PRICE_API_BASE_URL");

  return (
    configuredBaseUrl ||
    PRICE_SERVER_LIST[getServerKey(server)] ||
    PRICE_SERVER_LIST.PROD
  );
};

// Toggle to true/false, when developing or pushing code on production url.
// const isProd = process.env.NODE_ENV === "development" ? false : true;

// const getLandingUrl = () => {
//   return isProd ? "http:///" : "localhost:3000";
// };

let instance = axios.create({
  baseURL: getBaseURL(),
  timeout: 800000,
  // headers: {
  //   "Content-Type": "application/json"
  // }
});

// Interceptor for outgoing requests
instance.interceptors.request.use(
  (config) => {
    const token = getAccessToken();

    // Token endpoints should be anonymous and must not carry stale auth headers.
    if (token && !isTokenRequest(config?.url)) {
      config.headers["Authorization"] = "Bearer " + token;
      config.headers["access-token"] = "Bearer " + token;
    }
    // config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// flag Implementation of Refresh token -- to be uncommented and debugged once refresh token is provided
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  function(error) {
    const originalRequest = error.config;
    const responseStatus = error?.response?.status;

    if (!responseStatus || !originalRequest) {
      return Promise.reject(error);
    }

    if (responseStatus === 401 && isTokenRequest(originalRequest.url)) {
      redirectToSignIn();
      return Promise.reject(error);
    }

    if (responseStatus === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = getRefreshToken();
      let refreshTokenBody = new FormData();
      refreshTokenBody.append("refresh_token", refreshToken);
      refreshTokenBody.append("client_id", "flip_mobile");
      refreshTokenBody.append("grant_type", "refresh_token");
      refreshTokenBody.append(
        "scope",
        "openid email phone profile offline_access roles flipapi_api"
      );

      return instance
        .post("/connect/token", refreshTokenBody, {
          baseURL: getBaseURL(),
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        })
        .then((res) => {
          if (res.status === 201) {
            setTokens({
              access_token: res.data.access_token,
              refresh_token: res.data.refresh_token,
            });
            instance.defaults.headers.common["Authorization"] =
              "Bearer " + res.data.access_token;
            return instance({
              ...originalRequest,
              baseURL: originalRequest.baseURL || getBaseURL(),
            });
          }
        })
        .catch((error) => {
          clearTokens();
          localStorage.removeItem(USER_DATA);
          redirectToSignIn();
        });
    }
    // }

    return Promise.reject(error);
  }
);

export default instance;
